import React from 'react';
// import {Colors} from '../../../configs/colors';
import {LinkProps} from './Link.props';
import './Link.styles.css';
import {useNavigate} from "react-router-dom";
export const Link: React.FC<LinkProps> = ({
  onClick,
  children,
  text,
  url='',
  color = '',
  fontSize,
  cssClass
}) => {
  const navigate = useNavigate();
  return (<a href={url} className={"link-style " + cssClass} style={{color,fontSize}} onClick={onClick}>{text}{children}</a>);
};
